import {
  FormInput,
  Modal,
  PrimaryButton,
  copyTextToClipboard,
  useTranslation as useUiTranslation,
} from '@systemeio/ui'
import React from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import FormTextarea from './form-textarea'

export interface LinkShareModalProps {
  opened: boolean
  link: string | undefined
  title: string
  label: string
  onClose: () => void
  onOpen?: () => void
  showInTextArea?: boolean
  isLoading?: boolean
}

const LinkShareModal = ({
  link,
  opened,
  onClose,
  title,
  label,
  onOpen,
  showInTextArea = false,
  isLoading,
}: LinkShareModalProps) => {
  const { t } = useLocoTranslation()
  const { t: tUi } = useUiTranslation()

  return (
    <Modal afterEnter={onOpen} opened={opened} onClose={onClose} title={title}>
      <form className="flex flex-col gap-6 lg:gap-10">
        <div className="flex flex-col justify-center gap-3">
          {showInTextArea ? (
            <FormTextarea label={label} value={link} disabled isLoading={isLoading} />
          ) : (
            <FormInput label={label} value={link} disabled isPreFetching={isLoading} />
          )}
        </div>
        <div className="flex justify-center gap-4">
          <PrimaryButton
            disabled={isLoading}
            onClick={async (e: React.MouseEvent<HTMLButtonElement>) => {
              e.preventDefault()
              if (!link) return

              await copyTextToClipboard(link, tUi)
              onClose()
            }}
          >
            {t('global.copy_to_clipboard_caption')}
          </PrimaryButton>
        </div>
      </form>
    </Modal>
  )
}

export default LinkShareModal
